import { defineNuxtPlugin } from '#app'
import posthog from 'posthog-js'
import { USER_ID_COOKIE } from '~/configuration/global.configuration'

/**
 * PostHog plugin for tracking split test data
 * Only loads and initializes on the client side
 */
export default defineNuxtPlugin({
  name: 'posthog',
  parallel: true,
  setup() {
    const runtimeConfig = useRuntimeConfig()
    const posthogApiKey = runtimeConfig.public.posthogApiKey
    const posthogHost = runtimeConfig.public.posthogHost

    // Only proceed if PostHog is enabled and API key is provided
    if (!posthogApiKey || !runtimeConfig.public.posthogEnabled) {
      console.debug('PostHog integration is disabled or missing API key')
      return
    }

    const posthogClient = posthog.init(posthogApiKey, {
      api_host: posthogHost,
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      capture_pageview: false, // we add manual pageview capturing below
      autocapture: false,
      loaded: (posthog) => {
        if (import.meta.env.MODE === 'development')
          posthog.debug()
      },
    })

    return {
      provide: {
        posthog: () => posthogClient,
      },
    }
  },
})
